import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percentage',
    standalone: false
})
export class PercentagePipe implements PipeTransform {
    transform(value: number): string {
        if (value === undefined || value === null) {
            return '   ';
        }
        return (value * 100).toFixed(2) + '%';
    }
}
